import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import Scorecard from '@/creditflowresearch/ui/components/league/Scorecard';
import withScorecardProps from '@/creditflowresearch/application/League/Scorecard/withScorecardProps';
import getServerSideScorecardData from '@/creditflowresearch/application/League/serverSide/getServerSideScorecardData';
import ScorecardContextProvider from '@/creditflowresearch/application/League/Scorecard/ScorecardContext';
import getServerSideScorecardBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideScorecardBreadcrumbs';
import PageFiltersContextProvider, { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import { getProducts } from '@/creditflowresearch/application/Deal/helpers';
import getServerSideDealsByProduct from '@/creditflowresearch/application/Deal/helpers/utils/getServerSideDealsByProduct';
import { getLeagueCompaniesPayload } from '@/creditflowresearch/application/League/helpers';
import { IDealsPayload } from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporatePayload } from '@/creditflowresearch/application/Deal/types';

export const getServerSideProps = withScorecardProps(async (context) => {
  const { availableProductIds, activeProductId } = getProducts(context);

  const [deals, scorecardData, breadcrumbs] = await Promise.all([
    getServerSideDealsByProduct(context, {
      additionalFilters: getLeagueCompaniesPayload(context),
    }),
    getServerSideScorecardData(context),
    getServerSideScorecardBreadcrumbs(context),
  ]);

  return {
    props: {
      scorecardData,
      breadcrumbs,
      deals,
      availableProductIds,
      activeProductId,
    },
  };
});

const ScorecardWithFilters = ({ props }) => {
  const { additionalFilters } = usePageFiltersContext();
  return (
    <ScorecardContextProvider
      scorecardData={ props?.scorecardData }
      companyData={ props?.companyData }
      additionalFilters={ additionalFilters as IDealsPayload & ICorporatePayload }
    >
      <PageContentLayout>
        <Scorecard />
      </PageContentLayout>
    </ScorecardContextProvider>
  );
};

const IssuerName = (props) => (
  <PageFiltersContextProvider profileType={ ProfileTypes.INDUSTRY }>
    <ParentPageContextProvider parentProps={ {
      deals: props?.deals,
      availableProductIds: props?.availableProductIds,
      activeProductId: props?.activeProductId,
    } }
    >
      <ScorecardWithFilters props={ props } />
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default IssuerName;
